import React from "react";
import { RefreshCcw01 as RefreshCcw } from "@untitledui/icons";

import { SEVERITY_STYLE } from "../announcement/severity";

interface Props {
  onRefresh?: () => void;
}

/**
 * Persistent top-of-app banner shown when a newer build has been deployed than
 * the one currently loaded (see useAppUpdate). Not dismissible, it stays until
 * the user refreshes, which is the whole point.
 */
export const UpdateBanner: React.FC<Props> = ({ onRefresh }) => {
  const style = SEVERITY_STYLE.info;

  const handleRefresh = () => {
    if (onRefresh) onRefresh();
    else window.location.reload();
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "10px 16px",
        fontSize: 13,
        fontWeight: 500,
        background: style.bg,
        color: style.fg,
        borderBottom: `1px solid ${style.border}`,
      }}
      role="status"
      aria-live="polite"
    >
      <RefreshCcw className="w-5 h-5" />
      <div style={{ flex: 1, minWidth: 0 }}>
        A new version of Charti is available. Refresh to get the latest updates.
      </div>
      <button
        onClick={handleRefresh}
        style={{
          background: style.accent,
          color: "#fff",
          border: "none",
          borderRadius: 6,
          cursor: "pointer",
          padding: "6px 14px",
          fontSize: 13,
          fontWeight: 600,
          whiteSpace: "nowrap",
        }}
      >
        Refresh now
      </button>
    </div>
  );
};
